import { Link } from 'react-router-dom'
import { TicketsShell } from '../layout/TicketsShell'
import { usePageMeta } from '../hooks/usePageMeta'
import { schemaGraph, schemaWebPage } from '../lib/schema-org'

export function EventTicketsErrorPage() {
  usePageMeta({
    title: 'Zahlung fehlgeschlagen',
    description: 'Der Ticket-Checkout konnte nicht abgeschlossen werden.',
    canonical: '/events/tickets/error',
    noindex: true,
    jsonLd: schemaGraph(
      schemaWebPage({
        path: '/events/tickets/error',
        name: 'Zahlung fehlgeschlagen — BNKR Tickets',
        description: 'Ticket-Checkout bei BNKR nicht abgeschlossen.',
      }),
    ),
  })

  return (
    <TicketsShell backTo="/events">
      <div className="tickets-shell__message">
        <p className="kicker">TICKETS</p>
        <h1>Zahlung fehlgeschlagen</h1>
        <p>Bitte versuche es erneut oder wähle eine andere Zahlungsmethode.</p>
        <Link to="/events" className="btn-ghost-crt">← Zurück zu Events</Link>
      </div>
    </TicketsShell>
  )
}
